import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function getNextInvoiceRectificative (params = null) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      resolve(mock.getTipoEsquema)
    })
  } else {
    const req = {
      url: '/api/emisionfacturas/getnextinvoicerectificative',
      method: 'GET',
      params
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { getNextInvoiceRectificative }
